import React from 'react';

interface DragHandleIconProps {
  size?: number;
  className?: string;
}

const DragHandleIcon: React.FC<DragHandleIconProps> = ({ size = 16, className = '' }) => {
  // Calculate dimensions based on size
  const dotSize = Math.max(2, size / 8);
  const gap = Math.max(2, size / 8);
  const totalWidth = 2 * dotSize + gap;
  const totalHeight = 3 * dotSize + 2 * gap;

  // Scale to match the requested size
  const scale = size / Math.max(totalWidth, totalHeight);
  const width = totalWidth * scale;
  const height = totalHeight * scale;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${width} ${height}`}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* First row */}
      <circle cx={dotSize / 2} cy={dotSize / 2} r={dotSize / 2} />
      <circle cx={dotSize * 1.5 + gap} cy={dotSize / 2} r={dotSize / 2} />

      {/* Second row */}
      <circle cx={dotSize / 2} cy={dotSize * 1.5 + gap} r={dotSize / 2} />
      <circle cx={dotSize * 1.5 + gap} cy={dotSize * 1.5 + gap} r={dotSize / 2} />

      {/* Third row */}
      <circle cx={dotSize / 2} cy={dotSize * 2.5 + gap * 2} r={dotSize / 2} />
      <circle cx={dotSize * 1.5 + gap} cy={dotSize * 2.5 + gap * 2} r={dotSize / 2} />
    </svg>
  );
};

export default DragHandleIcon;
